module.exports = __webpack_public_path__ + "static/media/logo_white_foreseem.af38301e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo_white_foreseem.svg
// module id = 627
// module chunks = 0